export const NAME = 'companies';